import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { AnnouncementCreateInput } from "@colab/shared";

export type CreateAnnouncementResponse = {
  id: string;
  active: boolean;
  body: string;
};

// POST /api/settings/announcements
//
// Replaces revalidatePath("/admin/settings") + revalidatePath("/portal/dashboard")
// from /app/admin/settings/_actions.ts::createAnnouncement. Both invalidations
// fire on success — the second one because the new row is visible in the
// portal inbox strip.
export function useCreateAnnouncement() {
  const queryClient = useQueryClient();
  return useMutation<CreateAnnouncementResponse, ApiClientError, AnnouncementCreateInput>({
    mutationFn: (input) =>
      apiFetch<CreateAnnouncementResponse>("/settings/announcements", {
        method: "POST",
        body: JSON.stringify(input),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.settings.announcements() });
      queryClient.invalidateQueries({ queryKey: queryKeys.notifications.inbox() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to publish announcement");
    },
  });
}
